import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class DlpReportService {
  baseUrl = environment.apiUrl + 'RecordsDLP/';
  baseUrl2 = environment.apiUrl + 'Report/';

  constructor(
    private http: HttpClient,
    private router: Router,
    private _location: Location
  ) {}

  getAllDlpReports(
    page: number,
    pageSize: number,
    filters
  ): Observable<HttpResponse<any[]>> {
    return this.http.get<any[]>(
      this.baseUrl + `alerts?pg=${page}&pageSize=${pageSize}`,
      {
        observe: 'response',
        params: filters,
      }
    );
  }

  getTypes(): Observable<HttpResponse<any>> {
    return this.http.get<any>(this.baseUrl + `types`, { observe: 'response' });
  }

  getPolicies(): Observable<HttpResponse<any>> {
    return this.http.get<any>(this.baseUrl + `policy`, { observe: 'response' });
  }

  generateGeneralDlpReport(filters, language): Observable<HttpResponse<any>> {
    return this.http.get<any>(this.baseUrl2 + `alerts?culture=${language}`, {
      observe: 'response',
      params: filters,
    });
  }

  generateEvoDlpReport(filters, language): Observable<HttpResponse<any>> {
    return this.http.get<any>(
      this.baseUrl2 + `alerts-evo?culture=${language}`,
      { observe: 'response', params: filters }
    );
  }
}
